export type BeforeAfterItem = {
  before?: string;
  after: string;
  title: string;
  /** Small caption above the title (e.g. the style name). */
  tag?: string;
};

/** Example results: the result large (3:4), the original photo as a corner inset. */
export function BeforeAfterGallery({
  items,
  labels,
  subject,
}: {
  items: readonly BeforeAfterItem[];
  labels: { before: string; after: string };
  /** The tool name, so image alt text says what the picture is an example of. */
  subject?: string;
}) {
  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-10 sm:gap-x-6 lg:grid-cols-3">
      {items.map((item) => (
        <figure key={item.after}>
          <div className="relative aspect-[3/4] overflow-hidden rounded-2xl bg-muted shadow-sm ring-1 ring-black/5">
            <img
              src={item.after}
              alt={subject ? `${subject}: ${item.title}` : `${labels.after}: ${item.title}`}
              width={720}
              height={960}
              loading="lazy"
              decoding="async"
              className="size-full object-cover"
            />
            {item.before ? (
              <span className="absolute left-3 top-3 w-1/3 overflow-hidden rounded-lg border-2 border-white shadow-md">
                <img
                  src={item.before}
                  alt={`${labels.before}: ${item.title}`}
                  loading="lazy"
                  decoding="async"
                  className="aspect-[3/4] w-full object-cover"
                />
                <span className="absolute inset-x-0 bottom-0 bg-black/55 py-0.5 text-center text-[10px] font-semibold uppercase tracking-wide text-white">
                  {labels.before}
                </span>
              </span>
            ) : null}
          </div>
          <figcaption className="mt-4 space-y-1">
            {item.tag ? (
              <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{item.tag}</p>
            ) : null}
            <p className="text-sm font-semibold leading-6 text-foreground sm:text-base">{item.title}</p>
          </figcaption>
        </figure>
      ))}
    </div>
  );
}
